var path = '/var/www/mmscny-cms/src/app/components/report-view/report-view.html';
var html = "<report-repository-details details=$ctrl.details on-edit=$ctrl.onEdit($event) on-go-back=$ctrl.onGoBack() parent-slug={{$ctrl.parentSlug}} is-short-details={{$ctrl.isShortDetails}}> </report-repository-details>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/report-view/report-view.html
// module id = 785
// module chunks = 0